import FreeBusyType from '../schema/FreeBusyType';

/**
 * Converts a FreeBusyType value to a boolean whether it's free or busy block.
 * @param freeBusy FreeBusyType value
 */
export default function isConflictFromFreeBusy(
    freeBusy: FreeBusyType,
    isResource?: boolean
): boolean {
    return (
        freeBusy == FreeBusyType.Busy ||
        freeBusy == FreeBusyType.OOF ||
        (isResource && freeBusy == FreeBusyType.Tentative)
    );
}
